<template>
    <dx-popup
        :title="state.userRequestBody.fio"
        v-model:visible="state.userCardViewPopupVisible"
        :show-close-button="true"
        :animation="{ value: false }"
        max-width="1300px"
        width="90%"
        height="660px"
    >
        <div class="flex h-full w-full flex-col gap-3">
            <users-card :refreshHandler="refreshData" />
        </div>
        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Сохранить и закрыть" @click="updateUser" />
        </dx-toolbar-item>
        <dx-toolbar-item location="after" toolbar="bottom">
            <dx-button text="Отмена" @click="closePopup" />
        </dx-toolbar-item>
    </dx-popup>
</template>

<script setup>
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxPopup, DxButton } from 'devextreme-vue';
import usersCard from '@/views/administration/users/users-card.vue';
import usersLocalStore from './store';
import enviromentStore from '@/store/enviroment-data';
import { updateUserData } from '@/service/admin-service';
import { dxUiNotify } from '@/utils/dx-helper';

const { state } = usersLocalStore;

const closePopup = () => {
    state.userCardViewPopupVisible = false;
};

const refreshData = async () => {
    state.userRequestBody = {
        ...enviromentStore.state.officialData,
        ...enviromentStore.state.userData,
        id: enviromentStore.state.userData.id,
    };
};

const updateUser = async () => {
    const result = await updateUserData(state.userRequestBody);
    if (result.success) {
        dxUiNotify('Данные успешно обновлены', 'success');
        state.userCardViewPopupVisible = false;
    } else {
        dxUiNotify('Ошибка при сохранении данных', 'error');
    }
};
</script>
